document.addEventListener("DOMContentLoaded",function()
{

    function init()
    {
       // activarCarruselColecciones();
       activarCarruselBanners();
        carruselProductos();

    }

    function carruselProductos()
    {

        
        
       activarCarruselProductos(); 
       activarTabsProductos();

    }


     function activarCarruselBanners()
    {

            
        let elem = document.querySelectorAll(".banner-casabriller .banners");

        for(let i=0 ; i<elem.length ; i++)
        {
        
            let flkty = new Flickity(elem[i],
            {

                imagesLoaded:true,
                cellAlign: 'left',
                draggable:true,
                wrapAround:true,
                pageDots:true,
                autoPlay: 3000,
                prevNextButtons: false

            
            
            }
        
        );

        }

    }


    function activarCarruselProductos()
    {

            
        let elem = document.querySelectorAll(".productos_slider");

        for(let i=0 ; i<elem.length ; i++)
        {
        
            let flkty = new Flickity(elem[i],
            {

                imagesLoaded:true,
                cellAlign: 'left',
                draggable:true,
                wrapAround:true,
                pageDots:false
             

            
            
            }
        
        );

        }

    }



    
    function activarCarruselColecciones()
    {

            
        let elem = document.querySelectorAll(".browse-collection .colecciones");

        for(let i=0 ; i<elem.length ; i++)
        {
        
            let flkty = new Flickity(elem[i],
            {

                imagesLoaded:true,
                cellAlign: 'left',
                draggable:true,
                wrapAround:true,
                pageDots:false
             

            
            
            }
        
        );

        }

    }

    function activarTabsProductos()
    {

        const tabs = document.querySelectorAll(".tabs .tab");

        tabs.forEach((tab,index)=>
        {
        
            tab.addEventListener("click",function(e)
            {
            
                document.querySelector(".tabs .tab.activo").classList.remove("activo");
                e.target.classList.add("activo");


                document.querySelector(".contenido_tab.activo").classList.remove("activo");
                document.querySelector(".contenido_tabs #"+e.target.getAttribute("id")).classList.add("activo");


            });


        });


    }

    init();

});